import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import { getDefaultBaseSettingsConfigFormly } from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  defaultCustomSlotBookingConfigFormModel,
  getSlotBookingFieldSettingsConfig,
  slotBookingFieldParseIntoSettingsFormModel,
  slotBookingFieldUpdateFromSettingsFormModel,
} from '../custom-slot-booking.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class SlotBookingFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: any, field: any) {
    super(injector, field);

    this.settingsFormlyModel = defaultCustomSlotBookingConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...getSlotBookingFieldSettingsConfig(),
    ];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return slotBookingFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return slotBookingFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
